import { openBlock as t, createElementBlock as r, createElementVNode as n, normalizeClass as i, withDirectives as u, vModelCheckbox as m, createTextVNode as f, toDisplayString as c, renderSlot as b, createCommentVNode as s } from "vue";
import { _ as h } from "./_plugin-vue_export-helper-dad06003.js";
const _ = {
  name: "FormCheck",
  props: {
    modelValue: Boolean,
    label: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "blur"],
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(o) {
        this.$emit("update:modelValue", o);
      }
    }
  }
}, x = { class: "relative" }, y = ["disabled"], g = { class: "ml-3 text-sm" }, k = {
  key: 0,
  class: "font-medium ct-text-2 select-none"
}, V = {
  key: 0,
  class: "ct-text-error"
}, S = {
  key: 1,
  class: "ct-text-3"
};
function B(o, l, e, p, v, d) {
  return t(), r("div", x, [
    n("label", {
      class: i(["flex items-start", [e.disabled ? "" : "cursor-pointer"]])
    }, [
      u(n("input", {
        "onUpdate:modelValue": l[0] || (l[0] = (a) => d.model = a),
        type: "checkbox",
        class: i(["mt-0.5 h-4 w-4 outline-none border rounded bg-transparent focus:outline-none focus:ring-offset-0 disabled:ct-bg-disabled--subtle enabled:cursor-pointer", [
          e.error ? "ct-border-error focus:ct-ring-error-focus--shadow ct-text-error" : "ct-border-1 focus:ct-ring-focus--shadow ct-text-1"
        ]]),
        disabled: e.disabled,
        onBlur: l[1] || (l[1] = (a) => o.$emit("blur", a))
      }, null, 42, y), [
        [m, d.model]
      ]),
      n("div", g, [
        e.label || d.hasSlot ? (t(), r("p", k, [
          f(c(e.label) + " ", 1),
          b(o.$slots, "default"),
          e.required ? (t(), r("span", V, "*")) : s("", !0)
        ])) : s("", !0),
        e.info ? (t(), r("p", S, c(e.info), 1)) : s("", !0)
      ])
    ], 2),
    e.error ? (t(), r("p", {
      key: 0,
      class: i(["mt-2 text-sm", [e.error ? "ct-text-error" : "ct-text-3"]])
    }, c(e.error), 3)) : s("", !0)
  ]);
}
const F = /* @__PURE__ */ h(_, [["render", B]]);
export {
  F
};
